import {action, computed, observable} from "mobx";
import DashboardData from "./DashboardData";
import dashboardData from "./DashboardData";
import {ISolution} from "./SolutionDataSource";
import {UIState} from "./UIState";
import {DashboardSolution} from "./entities/DashboardSolution";

/**
 * Holds a current tally of points based on
 * supplied feed items along with the feed items
 * that correspond with those points
 *
 */
export class PointsDataSource {
	solution:ISolution;
	defaultFeedItemIcon = UIState.settings.DEFAULT_FEED_ITEM_ICON;	// TODO: pull from solution
	@observable earnedPointDescriptions:IEarnedPointDesc[] = [];

	@computed get relatedDashboardSolution() {
		return DashboardData.allDashboardSolutions.find((dashboardSolution)=>dashboardSolution._id===this.solution._id);
	}

	processFeedItems = (feedItems) => {
		for(let i=0;i<feedItems.length;i++) {
			this.processFeedItem(feedItems[i]);
		}
	}

	@action processFeedItem = (item) => {
		if(item.pointsAwarded && item.pointsAwardedDate && item.pointsAwarded>0) {
			const existingEarnedPointDescription = this.earnedPointDescriptions.find((earnedPointDesc)=>earnedPointDesc._id===item._id);
			if(!existingEarnedPointDescription) {
				const name = item.name ? item.name : (item._post ? item._post.title:(item.content?item.content:'Awarded points'));
				const icon = item.icon ? item.icon : (item._post ? item._post.icon : this.defaultFeedItemIcon);
				this.earnedPointDescriptions.push({
					_id:item._id,
					name:name,
					icon:icon,
					pointsAwarded:item.pointsAwarded,
					pointsAwardedDate:item.pointsAwardedDate,
				});
			}  else {
				existingEarnedPointDescription.pointsAwarded = item.pointsAwarded;
				existingEarnedPointDescription.pointsAwardedDate = item.pointsAwardedDate;
			}
		}
		if(this.relatedDashboardSolution) {
			this.relatedDashboardSolution.updatePoints(this.points);
		}
	}

	@computed get points() {
		let points = 0;
		for(let i=0;i<this.earnedPointDescriptions.length;i++) {
			points += this.earnedPointDescriptions[i].pointsAwarded;
		}
		return points;
	}

	private constructor(solution:ISolution, feedItems) {
		this.solution = solution;
		this.processFeedItems(feedItems);
	}

	static pointsDataSourceFactory = (solution:ISolution, feedItems) => new Promise<PointsDataSource>((resolve)=>{
		const pointsDataSource = new PointsDataSource(solution, feedItems);
		resolve(pointsDataSource);
	});

}



export interface IEarnedPointDesc {
	_id:string;
	icon:string;
	name:string;
	pointsAwarded:number;
	pointsAwardedDate: Date;
}
